import { Stack, Typography } from '@mui/material';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useParams } from 'react-router-dom';

import { ErrorLoadingPage, Loading } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import PrintSvg from '@assets/images/print.svg';

import { IconContainer, PrintWrapper } from '../PrintDiscount/styles';
import { FinancialIncomeReportCard } from '../FinancialIncomeReport/components';
import { formatDateForPrint } from './utils/formatDateForPrint';
import { useIncomeReportPrint } from '../FinancialIncomeReport/hooks';

export function PrintIncomeReportLayout() {
  const componentRef = useRef(null);
  const { year } = useParams<{ year: string }>();
  const { incomeReportPrintState, refreshIncomeReportPrint } =
    useIncomeReportPrint(Number(year));

  const printIncomeReportName = `Demonstrativo de IR - ${year}`;

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: printIncomeReportName,
  });

  document.title = printIncomeReportName;

  const { isLoading, isError, data } = incomeReportPrintState;

  if (isError) {
    return <ErrorLoadingPage onReloadClick={refreshIncomeReportPrint} />;
  }
  if (isLoading) {
    return (
      <Loading
        padding={8}
        message={
          <>
            Estamos carregando as informações. <br /> Em breve, tudo estará
            pronto para você
          </>
        }
      />
    );
  }
  return (
    <Stack>
      <Stack
        padding={4}
        justifyContent="flex-end"
        flexDirection="row"
        bgcolor={NEW_COLORS.GRAYSCALE[800]}
        alignItems="center"
        gap={2}
      >
        <IconContainer onClick={handlePrint}>
          <img
            width={16}
            height={16}
            src={PrintSvg}
            alt="Informe de rendimentos"
          />
        </IconContainer>
      </Stack>

      <Stack width="60vw" margin="auto">
        <div ref={componentRef}>
          <PrintWrapper>
            <Stack
              paddingTop={3}
              px={5}
              sx={{ background: NEW_COLORS.BASE.WHITE }}
            >
              <Stack
                width="100%"
                justifyContent="flex-end"
                alignItems="flex-end"
              >
                <Typography variant="subtitle1" fontWeight={400}>
                  {formatDateForPrint}
                </Typography>
              </Stack>
              <Typography variant="subtitle1" fontWeight={900}>
                Demonstrativo de Declaração de Imposto de Renda
              </Typography>
              <FinancialIncomeReportCard {...data} isPrint />
            </Stack>
          </PrintWrapper>
        </div>
      </Stack>
    </Stack>
  );
}
